import axios from "@/api/baseRequest.js";

//列出课题
export const apiListTopic = () => axios.get("/api/1/pub/topic/list");

//列出课题、章节和笔记
export const apiListTopicAndChapterAndNote = () => axios.get("/api/1/pub/topic/listTopicAndChapterAndNote");
